import "./search.css";
import { useState, useRef } from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import { Typeahead, withAsync } from "react-bootstrap-typeahead";
import Results from "./results";

const AsyncTypeahead = withAsync(Typeahead);

function Search() {
  const [checkboxChecked, setCheckboxChecked] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [results, setResults] = useState([]);
  const [renderResults, setRenderResults] = useState(false);
  const [location, setLocation] = useState({ lat: 0.0, lng: -180.0 });
  const [locationText, setLocationText] = useState("");
  const [locationFieldEnable, setLocationFieldEnable] = useState(true);
  const [category, setCategory] = useState("all");
  const formRef = useRef(null);
  const typeahead = useRef();
  const handlePopulate = (query) => {
    setIsLoading(true);
    fetch("/autocomplete?text=" + query)
      .then((res) => res.json())
      .then((data) => {
        let items = [];
        for (let i = 0; i < data["categories"].length; i++) {
          items.push(data["categories"][i].title);
        }
        for (let i = 0; i < data["terms"].length; i++) {
          items.push(data["terms"][i].text);
        }
        setOptions(items);
        setIsLoading(false);
      });
  };
  const filterBy = () => true;

  const handleClear = (e) => {
    e.preventDefault();
    setRenderResults(false);
    formRef.current.reset();
    typeahead.current?.clear();
    if (checkboxChecked === true) {
      setCheckboxChecked(false);
    }
    if (locationFieldEnable === false) {
      setLocationFieldEnable(true);
    }
    setCategory("all");
  };

  const handleCategoryChanged = (e) => {
    setCategory(e.target.value);
  };

  const handleCheckboxChecked = (e) => {
    if (checkboxChecked === true && locationFieldEnable === false) {
      setCheckboxChecked(false);
      setLocationFieldEnable(true);
    } else if (checkboxChecked === false && locationFieldEnable === true) {
      setCheckboxChecked(true);
      setLocationFieldEnable(false);
      formRef.current.formGridLocation.value="";
      setLocationText("");
      fetch("https://ipinfo.io?token=038db67791d2f3")
        .then((res) => res.json())
        .then((data) => {
          let loc = data["loc"].split(",");
          setLocation({
            lat: loc[0],
            lng: loc[1],
          });
        });
    } else if (checkboxChecked === true && locationFieldEnable === true) {
      console.log("whoa");
    }
  };
  const handleLocationText = (e) => {
    setLocationText(e.target.value);
    if (checkboxChecked === false) {
      fetch("/gmaps/search?location=" + e.target.value)
        .then((res) => res.json())
        .then((data) => {
          setLocation({
            lat: data.lat,
            lng: data.lng,
          });
        });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    //if checkmark checked: ip address -> lat long -> yelp
    fetch(
      "/businesses/search?term=" +
        e.target[0].value +
        "&latitude=" +
        location.lat +
        "&longitude=" +
        location.lng +
        "&categories=" +
        category +
        "&radius=" +
        e.target.elements.formGridDistance.value
    )
      .then((res) => res.json())
      .then((data) => {
        setRenderResults(true);
        setResults(data["businesses"]);
      });
  };
  let output;
  if (renderResults && results.length > 0) {
    output = <Results businessData={results} />;
  } else if (renderResults) {
    output = <p className="text-danger" style={{'fontSize':'1.4rem','fontWeight':500,'backgroundColor':'#ffffff','maxWidth':'25rem','borderRadius':'3rem','marginLeft':'auto','marginRight':'auto'}}>No results available</p>;
  } else {
    output = <></>;
  }
  return (
    <div className="search">
      <Card
        style={{ maxWidth: "47rem",'marginRight':'2rem','marginLeft':'1rem', 'borderRadius':'15px'}}
        className="mx-auto align-items-center viewport-height w-100"
      >
        <Card.Title style={{ paddingTop: "8vh" }}>Business search</Card.Title>
        <Card.Body style={{width:'95%'}}>
          <Form ref={formRef} className="form" onSubmit={handleSubmit}>
            <Row>
              <Col>
                <Form.Group className="mb-2" controlId="formGridKeyword">
                <Form.Label column="sm" lg={2}>
                  Keyword <font color="red">*</font>
                </Form.Label>
                <AsyncTypeahead
                  ref={typeahead}
                  isLoading={isLoading}
                  filterBy={filterBy}
                  useCache={false}
                  id="keyword"
                  minLength={2}
                  paginate={false}
                  onSearch={handlePopulate}
                  options={options}
                  inputProps={{ required: true }}
                  renderMenuItemChildren={(option) => <span>{option}</span>}
                />
              </Form.Group>
              </Col>
            </Row>
            <Row className="mb-3">
              <Form.Group as={Col} controlId="formGridDistance" xs={6}>
                <Form.Label column="sm">Distance</Form.Label>
                <Form.Control />
              </Form.Group>
              <div class="w-100 break-the-col"></div>
              <Form.Group as={Col} controlId="formGridCategory" xs={5}>
                <Form.Label column="sm">
                  Category <font color="red">*</font>
                </Form.Label>
                <Form.Select
                  aria-label="Default"
                  onChange={handleCategoryChanged}
                >
                  <option value="all">Default</option>
                  <option value="arts">Arts & Entertainment</option>
                  <option value="health">Health & Medical</option>
                  <option value="hotelstravel">Hotels & Travel</option>
                  <option value="food">Food</option>
                  <option value="professional">Professional Services</option>
                </Form.Select>
              </Form.Group>
            </Row>
            <Form.Group
              controlId="formGridLocation"
              onInput={handleLocationText}
            >
              <Form.Label column="sm" lg={2}>
                Location <font color="red">*</font>
              </Form.Label>
              <Form.Control required disabled={!locationFieldEnable} />
            </Form.Group>
            <br />
            <Form.Group className="mb-3" controlId="formGridCheckbox">
              <Form.Check
                type="checkbox"
                label="Auto-detect my location"
                onChange={handleCheckboxChecked}
              ></Form.Check>
            </Form.Group>
            <Row>
              <Col>
                <div class="text-center">
                  <Button
                    variant="danger"
                    className="submit-group"
                    type="submit"
                  >
                    Submit
                  </Button>
                  <Button
                    variant="primary"
                    className="submit-group"
                    onClick={handleClear}
                  >
                    Clear
                  </Button>
                </div>
              </Col>
            </Row>
            <br />
          </Form>
        </Card.Body>
      </Card>
      <br />
      <br />
      {output}
    </div>
  );
}
export default Search;
